const breakpoints = {
  extraSmall: 480,
  small: 768,
  medium: 992,
  large: 1280,
  extraLarge: 1440
};

export default breakpoints;
